import React from 'react'
import { makeActionCreator } from '../../config/store/utils'
import { formatDate } from '@chilecompra/react-kit'
import generatePDF from 'react-to-pdf'
import { onShowSnackbar } from '../SnackbarProvider/SnackbarProvider.actions'
import { onGetBasicBuyerInformationThunk } from '../BasicBuyerInformationSection/BasicBuyerInformationSection.actions'
import { onGetAveragePayThunk, onGetTotalPurchasesThunk } from '../SummarySection/SummarySection.actions'
import { onGetClaimInformationChartThunk } from '../ClaimsReceivedSection/ClaimsReceivedSection.actions'
import { onGetInstitutionalManagementThunk } from '../InstitutionalManagementSection/InstitutionalManagementSection.actions'
import { onGetDependentBuyerThunk } from '../DependentBuyerSection/DependentBuyerSection.actions'
import { onGetAnnualPurchasePlanThunk } from '../AnnualPurchasePlanSection/AnnualPurchasePlanSection.actions'
import { onGetTotalPurchaseOrdersThunk } from '../PurchaseOrdersSection/PurchaseOrdersSection.actions'
import { onGetTotalDemandsThunk } from '../PublicProcurementCourtClaimsSection/PublicProcurementCourtClaimsSection.actions'
import { onGetAverageBehaviorDataThunk, onGetBehaviorDataThunk } from '../BehaviorSection/BehaviorSection.actions'

export const GET_PDF_DATA = 'GET_PDF_DATA'
export const GET_PDF_DATA_SUCCESS = 'GET_PDF_DATA_SUCCESS'
export const onGetPDFData = makeActionCreator(GET_PDF_DATA)
export const onGetPDFDataSuccess = makeActionCreator(GET_PDF_DATA_SUCCESS)

export const onGetPDFdataThunk = payload => async dispatch => {
  dispatch(onGetPDFData())
  await Promise.all([
    dispatch(onGetBasicBuyerInformationThunk(payload)),
    dispatch(onGetTotalPurchasesThunk(payload)),
    dispatch(onGetAveragePayThunk(payload)),
    dispatch(onGetClaimInformationChartThunk(payload)),
    dispatch(onGetInstitutionalManagementThunk({ dni: payload })),
    dispatch(onGetDependentBuyerThunk({ dni: payload })),
    dispatch(onGetAnnualPurchasePlanThunk({ dni: payload })),
    dispatch(onGetTotalPurchaseOrdersThunk(payload)),
    dispatch(onGetTotalDemandsThunk(payload)),
    dispatch(onGetAverageBehaviorDataThunk({ dni: payload })),
    dispatch(onGetBehaviorDataThunk({ dni: payload, fromDownload: true }))
  ])
  return dispatch(onGetPDFDataSuccess())
}

export const DOWNLOAD_PDF = 'DOWNLOAD_PDF'
export const onDownloadPdf = makeActionCreator(DOWNLOAD_PDF)

export const onDownloadPdfThunk = payload => async dispatch => {
  dispatch(onDownloadPdf())
  try {
    const containerRef = React.createRef()
    containerRef.current = payload.contentContainer
    const getCurrentDate = new Date()
    const options = {
      filename: `Ficha_comprador_${payload.dni}_${formatDate(getCurrentDate, 'dd-MM-yyyy')}.pdf`,
      page: {
        margin: 20
      }
    }

    await generatePDF(containerRef, options)

    return dispatch(onShowSnackbar({ message: 'Ficha en pdf descargada con éxito', severity: 'success' }))
  } catch (error) {
    dispatch(
      onShowSnackbar({
        message: 'Hubo un error al descargar el documento. Intentelo más tarde',
        severity: 'error'
      })
    )
  }
}
